/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectKeyOrId } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

export type PriorityFilterData = {
	maxResults: number;
	startAt: number;
	total: number;
	isLast: boolean;
	values: {
		self: string;
		statusColor: string;
		description: string;
		iconUrl: string;
		name: string;
		id: string;
		isDefault: boolean;
	}[];
};

export const priorityFilterResource: RouteResource<PriorityFilterData> =
	createResource<PriorityFilterData>({
		type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
		getKey: ({ match }) => getProjectKeyOrId(match),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "escalations/priority-filter-resource", jiraSpaEntry: "escalations/priority-filter-resource" */ './GetDataGetData.tsx'
			),
	});

export const usePriorityFilterResource = (): UseResourceHookResponse<PriorityFilterData> =>
	useResource<PriorityFilterData>(priorityFilterResource);
